export default __webpack_public_path__ + "images/19511b66878868c461d6d23e3f0462c2-fall_seasonal_desktop.webp";